import React from 'react'

import { DealsProvider } from './deals/state/DealsProvider'
import { FilterProvider } from './deals/state/FilterProvider'
import { ModalProvider } from './deals/state/ModalProvider'
import { PageHeader } from './deals/layout/PageHeader'
import { PageSubheader } from './deals/layout/PageSubheader'
import { DealTable } from './deals/list/DealTable'
import { ModalRoot } from './deals/modals/ModalRoot'
import { useAllDealsForCountsQuery } from './deals/hooks/useDealsQuery'

import './deals/deals.css'

const DealsPageBody: React.FunctionComponent = () => {
  const allDealsQuery = useAllDealsForCountsQuery()
  const allDeals = allDealsQuery.data?.deals ?? []

  return (
    <div className="deal-page-root page-container">
      <PageHeader />
      <PageSubheader allDeals={allDeals} />
      <DealTable />
      <ModalRoot />
    </div>
  )
}

export const CrudDeals = () => {
  return (
    <DealsProvider>
      <FilterProvider>
        <ModalProvider>
          <DealsPageBody />
        </ModalProvider>
      </FilterProvider>
    </DealsProvider>
  )
}
